<template>
    <section id="map">
        <div v-if="!agreedToGDPR && !skipGdprCheck" id="staticMap" :style="staticMapUrl">
            <GDPROverlay :accepted.sync="agreedToGDPR" :appliedTo="$t('Map.label.mapDisplay')" />
        </div>
        <LeafletMap v-else :markers="markers">
            <!-- Deep child scoped slot passing down -->
            <template v-slot:popup="scope">
                <slot name="popup" v-bind="scope"></slot>
            </template>
            <!-- All deep child scoped slots passing down commented for future-->
            <!--<template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope"><slot :name="slot" v-bind="scope"/></template>-->
        </LeafletMap>

        <small class="text-muted small d-print-none" id="staticMapNotice">
            <translate path="Map.GDPRtext" :params="{ appliedTo: $t('Map.label.mapDisplay') }">
                <template v-slot:link>
                    <nuxt-link :to="{ name: 'category', params: { category: 'datenschutz' } }" target="_blank">
                        {{ $t('DataProtection.link') }}
                    </nuxt-link>
                </template>
            </translate>
        </small>

        <slot></slot>
    </section>
</template>

<script>
import GDPROverlay from '@/components/GDPROverlay';
import LeafletMap from '@/components/map/LeafletMap';

export default {
    name: 'HotelMap',
    components: {
        LeafletMap,
        GDPROverlay
    },
    data() {
        return {
            staticMapParams: {
                key: this.$config.googleApiKey,
                scale: 2,
                size: '1140x800',
                maptype: 'roadmap',
                format: 'png',
                visual_refresh: true
            }
        };
    },
    props: {
        center: {
            type: Array,
            default() {
                return [50.906861, 6.976514];
            }
        },
        zoom: {
            type: Number,
            default: 4
        },
        markers: {
            type: Array
        },
        skipGdprCheck: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        staticMapUrl() {
            const center = this.center.join('+');
            const zoom = this.zoom;

            const paramsObj = {
                center,
                zoom,
                ...this.staticMapParams
            };

            //product details or hotel usually provide one marker
            if (this.markers && this.markers.length === 1) {
                const { lat, lng } = this.markers[0].pos;
                const location = `${lat},${lng}`;
                const markerParams = {
                    anchor: '16,45',
                    icon: 'https://animod.de/img/map-marker-v3.png',
                    size: 'mid',
                    color: '0xff0000',
                    scale: 2
                };

                const markerParamsArr = Object.keys(markerParams).reduce((paramsArray, key) => {
                    paramsArray.push(`${key}:${markerParams[key]}`);
                    return paramsArray;
                }, []);
                markerParamsArr.push(location);
                const markersString = markerParamsArr.join('|');
                paramsObj.markers = encodeURI(markersString);
            }

            const params = Object.keys(paramsObj)
                .reduce((paramsArray, key) => {
                    paramsArray.push(key + '=' + paramsObj[key]);
                    return paramsArray;
                }, [])
                .join('&');
            return {
                background: `url(https://maps.animod.de/maps/api/staticmap?${params}) center`
            };
        },
        theme() {
            return this.$store.state.theme;
        },
        agreedToGDPR: {
            get() {
                return this.$store.state.agreedToGDPR;
            },
            set() {
                this.$store.dispatch('agreeToGDPR');
            }
        }
    }
};
</script>

<style scoped lang="scss">
#staticMap {
    height: 550px;
    display: block;
}
</style>
